exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thumbnails[data-v-624a12c4] {\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  align-items: center;\n  padding: 0;\n  margin: 0;\n  margin-top: 20px;\n}\n.thumbnail[data-v-624a12c4] {\n  opacity: 0.5;\n  width: 65px;\n  cursor: pointer;\n}\n.selected[data-v-624a12c4] {\n  opacity: 1;\n}\n.thumbnail[data-v-624a12c4]:hover {\n  opacity: 1;\n}", ""]);

// exports
